import { render, staticRenderFns } from "./BeigeMap.vue?vue&type=template&id=fdc70ae6&scoped=true&"
import script from "./BeigeMap.vue?vue&type=script&lang=js&"
export * from "./BeigeMap.vue?vue&type=script&lang=js&"
import style0 from "./BeigeMap.vue?vue&type=style&index=0&id=fdc70ae6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdc70ae6",
  null
  
)

export default component.exports